var path = '/app/core/views/partials/footer.partial.html';
var html = "<div class=\"layout-column layout-align-center-center b-footer__copyright\"> <div> <span> Copyright </span> <i class=\"fa fa-copyright\" aria-hidden=true></i> <span> {{footervm.currentDate || authvm.currentDate}} Cadena Apps S.A.S. Todos los derechos reservados. </span> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/core/views/partials/footer.partial.html
// module id = 199
// module chunks = 15